import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ORBITS = [
  { size: "58%", duration: 30, dir: 1, tone: "border-brand-red/25" },
  { size: "78%", duration: 44, dir: -1, tone: "border-brand-black/15" },
  { size: "98%", duration: 64, dir: 1, tone: "border-brand-red/15" },
];

const SATS = [
  { label: "Sicurezza 81/08", to: "/corsi/sicurezza-lavoro", orbit: 0, angle: -90, accent: "red" },
  { label: "Antincendio", to: "/corsi/antincendio-primo-soccorso", orbit: 0, angle: 90, accent: "black" },
  { label: "Primo Soccorso", to: "/corsi/antincendio-primo-soccorso", orbit: 0, angle: 210, accent: "black" },
  { label: "BLS-D Laico", to: "/corsi/bls-d", orbit: 1, angle: -30, accent: "red" },
  { label: "BLS-D Sanitario", to: "/corsi/blsd-sanitario", orbit: 1, angle: 150, accent: "black" },
  { label: "HACCP", to: "/corsi/sicurezza-alimentare", orbit: 1, angle: 270, accent: "red" },
  { label: "FGAS", to: "/fgas", orbit: 2, angle: 55, accent: "red" },
  { label: "Bandi", to: "/aziende", orbit: 2, angle: 235, accent: "black" },
];

const pos = (angle) => {
  const r = (angle * Math.PI) / 180;
  return {
    left: `${50 + 47 * Math.cos(r)}%`,
    top: `${50 + 47 * Math.sin(r)}%`,
  };
};

export const LogoUniverse = () => {
  return (
    <div data-testid="logo-universe" className="absolute inset-0 bg-transparent overflow-hidden pointer-events-none" aria-hidden="true">
      <div className="absolute inset-0 opacity-[0.045] bg-[linear-gradient(to_right,#0a0a0a_1px,transparent_1px),linear-gradient(to_bottom,#0a0a0a_1px,transparent_1px)] bg-[size:46px_46px]" />
      {[...Array(22)].map((_, i) => (
        <motion.span
          key={i}
          className={`absolute w-1 h-1 rounded-full ${i % 4 === 0 ? "bg-brand-red/70" : "bg-brand-black/25"}`}
          style={{ left: `${(i * 53) % 100}%`, top: `${(i * 37) % 100}%` }}
          animate={{ opacity: [0.2, 0.9, 0.2], scale: [1, 1.8, 1] }}
          transition={{ duration: 2.4 + (i % 5) * 0.4, repeat: Infinity, delay: i * 0.12 }}
        />
      ))}

      <div className="absolute left-1/2 top-1/2 aspect-square w-[min(86vmin,820px)] -translate-x-1/2 -translate-y-1/2">
        {ORBITS.map((o, oi) => (
          <motion.div
            key={oi}
            className={`absolute left-1/2 top-1/2 rounded-full border ${o.tone}`}
            style={{ width: o.size, height: o.size, x: "-50%", y: "-50%" }}
            animate={{ rotate: o.dir * 360 }}
            transition={{ duration: o.duration, repeat: Infinity, ease: "linear" }}
          >
            {SATS.filter((s) => s.orbit === oi).map((s) => (
              <Link
                key={s.label}
                to={s.to}
                aria-label={`Vai a ${s.label}`}
                data-testid={`orbit-link-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="absolute -translate-x-1/2 -translate-y-1/2 pointer-events-auto"
                style={pos(s.angle)}
              >
                <motion.div
                  className="flex items-center gap-1.5 border border-brand-black/15 bg-white/95 px-3.5 py-2.5 shadow-[0_12px_30px_-20px_rgba(10,10,10,0.55)] whitespace-nowrap transform-gpu"
                  animate={{ rotate: o.dir * -360 }}
                  transition={{ duration: o.duration, repeat: Infinity, ease: "linear" }}
                  whileHover={{ scale: 1.08, borderColor: "#D62828" }}
                >
                  <span className={`w-1.5 h-1.5 rounded-full ${s.accent === "red" ? "bg-brand-red" : "bg-brand-black"}`} />
                  <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-[0.14em] text-brand-black">
                    {s.label}
                  </span>
                </motion.div>
              </Link>
            ))}
          </motion.div>
        ))}

        <motion.div
          className="absolute left-1/2 top-1/2 z-10 w-[30%] max-w-[230px] aspect-square rounded-full flex items-center justify-center drop-shadow-[0_30px_50px_rgba(214,40,40,0.28)]"
          style={{ x: "-50%", y: "-50%" }}
          animate={{ scale: [1, 1.035, 1] }}
          transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
        >
          <motion.div
            className="absolute inset-[-14%] rounded-full border border-brand-red/30"
            animate={{ scale: [0.92, 1.12], opacity: [0.55, 0] }}
            transition={{ duration: 2.8, repeat: Infinity, ease: "easeOut" }}
          />
          <img src="/logo-mark.png" alt="" className="w-[72%] h-auto select-none" draggable="false" />
        </motion.div>
      </div>
    </div>
  );
};
